import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EmployeeAttendance } from '@/components/employee/attendance';

const attendanceDetailSearchSchema = z.object({
  startDate: z.string().optional(), // YYYY-MM-DD
  endDate: z.string().optional(), // YYYY-MM-DD
});

export const Route = createFileRoute('/(app)/company/attendance/$employeeId')({
  component: AttendanceDetailRoute,
  validateSearch: attendanceDetailSearchSchema,
});

function AttendanceDetailRoute() {
  const { employeeId } = Route.useParams();
  const employeeIdNum = Number(employeeId);
  
  return (
    <EmployeeAttendance 
      employeeId={employeeIdNum}
      showBackButton
      backPath="/company/attendance"
    />
  );
}

